// components/domain-assignment/components/RubricTable.js
import React from 'react';

const RubricTable = ({ rubric, editable = false, onChange }) => {
    return (
        <div className="border border-orange-300 rounded-lg overflow-hidden">
            <table className="min-w-full border-collapse">
                <thead>
                    <tr>
                        <th className="border border-orange-300 bg-orange-100 p-3 text-left text-orange-800 font-semibold w-1/4">
                            Abilities
                        </th>
                        <th className="border border-orange-300 bg-blue-100 p-3 text-center text-blue-800 font-semibold w-1/4">
                            Stream
                        </th>
                        <th className="border border-orange-300 bg-green-100 p-3 text-center text-green-800 font-semibold w-1/4">
                            Mountain
                        </th>
                        <th className="border border-orange-300 bg-purple-100 p-3 text-center text-purple-800 font-semibold w-1/4">
                            Sky
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {rubric.map((row, index) => (
                        <tr key={index}>
                            <td className="border border-orange-200 p-3 font-medium bg-orange-50">
                                {row.criterion}
                            </td>
                            <td className="border border-orange-200 p-3 text-sm bg-blue-50">
                                {editable ? (
                                    <textarea
                                        className="w-full p-2 border border-blue-200 rounded focus:ring-2 focus:ring-blue-500 text-sm"
                                        value={row.stream || ''}
                                        onChange={(e) => onChange(index, 'stream', e.target.value)}
                                        rows={3}
                                    />
                                ) : (
                                    row.stream
                                )}
                            </td>
                            <td className="border border-orange-200 p-3 text-sm bg-green-50">
                                {editable ? (
                                    <textarea
                                        className="w-full p-2 border border-green-200 rounded focus:ring-2 focus:ring-green-500 text-sm"
                                        value={row.mountain || ''}
                                        onChange={(e) => onChange(index, 'mountain', e.target.value)}
                                        rows={3}
                                    />
                                ) : (
                                    row.mountain
                                )}
                            </td>
                            <td className="border border-orange-200 p-3 text-sm bg-purple-50">
                                {editable ? (
                                    <textarea
                                        className="w-full p-2 border border-purple-200 rounded focus:ring-2 focus:ring-purple-500 text-sm"
                                        value={row.sky || ''}
                                        onChange={(e) => onChange(index, 'sky', e.target.value)}
                                        rows={3}
                                    />
                                ) : (
                                    row.sky
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default RubricTable;